import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../services/apiServices/security/authentication.service';
import {PasswordService} from '../../services/apiServices/security/password.service';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CommonService} from '../../services/apiServices/business/common.service';

/**
 * Component that handle the creation of a new password (not change!)
 * it use the create-password component to handle the creation
 */
@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit {

  /**
   * the new password
   */
  public newPassword: string;

  /**
   * the 2nd entry for the new password (they should match)
   */
  public verifyPassword: string;

  /**
   * if the new password is valid regarding security policy
   */
  public isNewPasswordValid: boolean;
  /**
   * if the new password is valid regarding security policy
   */
  public isNewPasswordConfirmValid: boolean;

  /**
   * if the creation of the new password fail
   */
  public createNewPasswordFail: boolean;

  /**
   * the token temporary gave by the back-office
   */
  private temporaryToken: string;

  /**
   * the errorMessage (if the back-office gave one)
   */
  public errorMessage: string;

  /**
   * Message display when the new password is ok
   */
  public successMessage: string;
  public passwordInvalidMsg: string;
  public passwordConfirmInvalidMsg: string;

  /**
   * Title of the message, display when the new password is ok
   */
  public successTitle: string;

  /**
   *
   * default constructor that instantiate services (if not done before)
   *
   * @param {ActivatedRoute} route - useful to get queryParams
   * @param {Router} router - useful to navigate after a successful change
   * @param {AuthenticationService} authenticationService - permit to logout (to avoid token conflict)
   * @param {PasswordService} passwordService - permit to create the password)
   * @param {MessageService} messageService - handleChangeOfSelectFold notification to display on login
   * @param {TranslateService} translate  - handleChangeOfSelectFold message translation
   */
  constructor(private route: ActivatedRoute, private router: Router, private  authenticationService: AuthenticationService,
              private passwordService: PasswordService, private commonService: CommonService, private translate: TranslateService) {
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((title: string) => {
      this.successTitle = title;
    });
    this.translate.get('TOASTER.NEW_PASSWORD_OK').subscribe((message: string) => {
      this.successMessage = message;
    });
    this.translate.get('CREATE.PASSWORD_COMPONENT.INPUT_PROMPT_LABEL').subscribe(message => {
      this.passwordInvalidMsg = message;
    });
    this.translate.get('CREATE.PASSWORD_COMPONENT.COFIRM_IDENTICAL').subscribe(message => {
      this.passwordConfirmInvalidMsg = message;
    });
  }

  /**
   * handleChangeOfSelectFold queryParams, logging out and subscriptions to errorMessage (from passwordService)
   */
  public ngOnInit(): void {
    this.isNewPasswordValid = false;
    this.isNewPasswordConfirmValid = false;
    this.temporaryToken = this.route.snapshot.queryParams['t'] || '/';
    this.authenticationService.logout();

    this.createNewPasswordFail = false;
    this.passwordService.errorMessage.subscribe(
      error => {
        this.errorMessage = error;
      }
    );
    this.getTradForComponent();
  }

  /**
   * handleChangeOfSelectFold the creation of the new password (if success it will redirect to the login page)
   */
  public createNewPassword(): void {
    this.passwordService.createNewPassword(this.newPassword, this.verifyPassword, this.temporaryToken).subscribe(result => {
      this.createNewPasswordFail = !result;
      if (result) {
        this.commonService.addToast({life: 3000, severity: 'success', summary: this.successTitle, detail: this.successMessage});
        setTimeout(() => {
          this.authenticationService.logout();
          this.router.navigateByUrl('');
        }, 1000);
      }
    });
  }
}
